import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import i18n from './i18n'
import axios from 'axios'

loadFonts()

axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URL ?? 'http://localhost'

// Token de cliente para los endpoints públicos que mutan. El backend lo exige
// (middleware client_token) cuando PUBLIC_CLIENT_TOKEN está configurado.
if (process.env.VUE_APP_CLIENT_TOKEN) {
  axios.defaults.headers.common['X-Client-Token'] = process.env.VUE_APP_CLIENT_TOKEN
}

createApp(App).use(i18n)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')
